// src/vuex/mutation_type.js
export const UID = "UID";
export const ERROR_STATE = "ERROR_STATE";
export const IS_AUTH = "IS_AUTH";
